export default {"src":"/_next/static/media/volvo-wordmark-black.e6bab9f1.svg","height":20,"width":258,"blurWidth":0,"blurHeight":0};